import { useUsersContext } from 'contexts/UsersContext';

import { SectionType } from 'sections/TabWrap';
import { EditForm } from 'sections/EditForm';

import { useFormData } from './useFormData.hooks';

const useShippingAddress = () => {
  const { form, onSubmit, user } = useUsersContext();
  const formData = useFormData(form?.watch);

  const sections: SectionType[] = [
    {
      id: 1,
      content: (
        <EditForm
          isDirty={form?.formState?.isDirty}
          onSubmit={onSubmit}
          data={formData}
          register={form?.register}
          reset={form?.reset}
          initialValues={user}
          control={form?.control}
        />
      ),
    },
  ];

  return {
    sections,
  };
};

export { useShippingAddress };
